import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/charts";
import { Tabs, Card, Col, Row,Button,Select, notification} from "antd";
import { redondear_numero } from "./analisis_data";
import "./Graph.scss";
import { getExcelQuentin } from "../../../api/user";
import { getAccessTokenApi } from "../../../api/auth";
import TableNoEditable from "../../../components/table/tableNoEditable/TableNoEditable";
import { post } from "../../../api/post";
import { get} from "../../../api/get";
import Billing from "../../../components/Admin/Billing";
import Map_polilineas from "../../../components/Admin/Map_polilineas";
import Map_economy from "../../../components/Admin/Map_polilineas/Map_economy.js";
import Map_real from "../../../components/Admin/Map_polilineas/Map_real.js";
import Map_nomanaged from "../../../components/Admin/Map_polilineas/Map_NOMANAGED.js";
import ProgressBar from "../../../components/Admin/Graphs/Progress";
// import {Checkbox } from "antd";


export default function GraphOUTPUTS(props) {
  const { Option } = Select;
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let code = params.get("id");
  // var id_excel = code.split(".")[0];
  var id_excel = code.replace('.xlsx','');
  const token = getAccessTokenApi(); //Authorization token

  const [OUT2_Orders, setOUT2_Orders] = useState([]);
  const [OUT3_Tours, setOUT3_Tours] = useState([]);
  const [IN3_Vehicles, setIN3_Vehicles] = useState([]);
  const [data_OPT1_TOURS, setdata_OPT1_TOURS] = useState([]);
  const [col_OPT1_TOURS, setcol_OPT1_TOURS] = useState([]);
  const [data_OUT1_TOTAL, setdata_OUT1_TOTAL] = useState([]);
  const [col_OUT1_TOTAL, setcol_OUT1_TOTAL] = useState([]);
  const [puntos, setpuntos] = useState([]);
  const [data_MAX_FLEET_INFO, setdata_MAX_FLEET_INFO] = useState({});
  const [real_data, setreal_data] = useState([]);
  const [rr_bool, setrr_bool] = useState(false);
  const [quentincontenedores, setquentincontenedores] = useState([]);
  const [quentinvehiculos, setquentinvehiculos] = useState([]);
  const [quentindemand, setquentinquentindemand] = useState([]);
  const [tours_capacity_JSON, settours_capacity_JSON] = useState([]);
  const [orderNoManaged, setorderNoManaged] = useState([]);
  const [avarage_fill_rate, setavarage_fill_rate] = useState(['0.0']);
  const [capacity_total_used, setcapacity_total_used] = useState(['0.0']);
  const [percentage_of_use, setpercentage_of_use] = useState(['0.0']);
  const [nombre, setnombre] = useState('');
  const [nombreInput, setnombreInput] = useState('');
  const [fecha, setfecha] = useState([]);
  const [next, setnext] = useState([]);
  const [cambios, setcambios] = useState([]);
  const [subsimulations, setsubsimulations] = useState([]);
  const [SelectedSimualtion, setSelectedSimualtion] = useState('');
  const [viewother, setviewother] = useState(false);
  const [hayData, sethayData] = useState(false);
  const [totalData, settotalData] = useState([]);
  const [hayError, sethayError] = useState(false);
  const [iva, setiva] = useState(10);
  

  useEffect( () =>  {
    
    const token = getAccessTokenApi();
    var DATA ;
    var isMain = true
    var subsimul = '';
    (SelectedSimualtion.length>1)
      ?(SelectedSimualtion==code)
        ?isMain=true
        :isMain=false
      :isMain=true

    if(isMain===false){subsimul=SelectedSimualtion}
    
    const dat = {
      isMain: isMain,
      subsimul:subsimul
    }
    post(dat,'getExcelRaw','getExcelRaw',`/${id_excel}`).then((response) => {
    // getExcelFromID(token, id_excel,isMain,subsimul).then((response) => {
      DATA = response.DATA;
      console.log('getExcelFromID: ',response.DATA);
      var fechas=String(DATA.horaOutput).replace('-',' ')
      fechas=fechas.slice(0,-3)
      // setOUT2_Orders(DATA.)
      
      settotalData(DATA)
      console.log('in',DATA.Real_Data,DATA.Real_Data.routes_data.length>0)
      if(DATA.Real_Data.routes_data.length>0){
        setrr_bool(true)
        console.log('in')
        setreal_data(DATA.Real_Data)
      }
      setfecha(fechas)
      sethayError(DATA.error)
      setnombre(DATA.nombre)
      setnombreInput(DATA.nombreInput)
      if(isMain)setnext(DATA.next)
      if(isMain){setcambios(DATA.changes)} else setcambios('')
      console.log(DATA.OPT1_Tours)
      console.log(DATA.OUT3_Tours)
      var OUT3_aux=[]
      for (let i = 0; i < DATA.OUT3_Tours.length; i++) {
        OUT3_aux.push({
          tour_id:DATA.OUT3_Tours[i].tour_id,
          tour_idtransptype:DATA.OUT3_Tours[i].tour_idtransptype,
          tour_departuretime:DATA.OUT3_Tours[i].tour_start_timestamp,
          tour_end_timestamp:DATA.OUT3_Tours[i].tour_end_timestamp,
        })
      }
      setdata_OPT1_TOURS(OUT3_aux);
      
      if(DATA.OUT2_Orders.length>1 
        // && 
        // DATA.OUT1_Total.length>0 && 
        // DATA.OUT3_Tours.length>0 && 
        // DATA.OUT4_Transp.length>0 && 
        // DATA.OPT1_Tours.length>0 && 
        // DATA.OPT2_Orders.length>0
        ){
        // console.log(DATA.OUT2_Orders)
        sethayData(true)
        if(DATA.simulaciones!==undefined){
          var subsim=DATA.simulaciones
          var aux=subsim.map(simul => <Option value={simul.nombreInput}>{simul.nombre}</Option>)
          aux.push(<Option value={DATA.nombreInput}>{DATA.nombre}</Option>)
          setsubsimulations(aux)
        }
         
         getExcelQuentin(DATA,token).then((response) => {
        //  console.log('getExcelQuentin: ',response.summary);
    
          var contenedores = [];
          contenedores.push(
            <h1 className="titulos3">{response.summary.vehiculos.title}</h1>
          );
          response.summary.vehiculos.variable_veh.forEach((element) => {
            if (element.variable) {
              contenedores.push(
                <Card title={element.nombre} style={{fontFamily:'report-bold'}}>
                  <p style={{fontFamily:'report'}}>{response.summary.vehiculos.interpretacion}</p>
                </Card>
              );
            } else {
              contenedores.push(
                <Card title={element.nombre} style={{fontFamily:'report-bold'}}>
                  <p style={{fontFamily:'report'}}>{"Everything is okey!"}</p>
                </Card>
              );
            }
          });
          setquentinvehiculos(contenedores);
    
          contenedores = [];
          contenedores.push(
            <h1 className="titulos3">{response.summary.demandaoferta.title}</h1>
          );
          if (response.summary.demandaoferta.variable) {
            contenedores.push(
              <Card title={response.summary.demandaoferta.title}  style={{fontFamily:'report-bold'}}>
                <p style={{fontFamily:'report'}}>{response.summary.demandaoferta.interpretacion}</p>
              </Card>
            );
          } else {
            contenedores.push(
              <Card title={response.summary.demandaoferta.title}  style={{fontFamily:'report-bold'}}>
                <p style={{fontFamily:'report'}}>{"Everything is okey!"}</p>
              </Card>
            );
          }
          setquentinquentindemand(contenedores);
    
          contenedores = [];
          contenedores.push(
            <h1 className="titulos3">{response.summary.hub.title}</h1>
          );
          response.summary.hub.variable_hub.forEach((element) => {
            if (element.variable) {
              contenedores.push(
                <Card title={element.nombre}  style={{fontFamily:'report-bold'}}>
                  <p style={{fontFamily:'report'}}>{response.summary.hub.interpretacion}</p>
                </Card>
              );
            } else {
              contenedores.push(
                <Card title={element.nombre}  style={{fontFamily:'report-bold'}}>
                  <p style={{fontFamily:'report'}}>{"Everything is okey!"}</p>
                </Card>
              );
            }
          });
          setquentincontenedores(contenedores);
          settours_capacity_JSON(response.tours);
          setavarage_fill_rate(response.percentages.avg_fill);
          setcapacity_total_used(response.percentages.total_capacity_used);
          setpercentage_of_use(response.percentages.vol_horario_veh);
  
        });
        
        const dat ={
          isMain: isMain,
          subsimul:subsimul
        }
        post(dat,'getExcelProcess','getExcelProcess',`/${id_excel}`).then((response) => {
        // getExcelFromIDProcessed(token, id_excel,isMain,subsimul).then((response) => {
          console.log(response.DATA.OUT3_Tours)
          setOUT3_Tours(response.DATA.OUT3_Tours);
          // console.log('getExcelFromIDProcessed: ',response.DATA)
          var col = [];
          var puntos_hubs = [];
          response.DATA.IN_HUB.map(function (x) {
            puntos_hubs.push({
              punto1: [x.hub_lat, x.hub_lon],
              nombre: x.hub_name,
              hub_monthlypayment:x.hub_monthlypayment
            });
          });
  
          var puntos2 = [];
          var tours = [];
          var ultimo_punto;
          var ship_vector=[]
          var noMan=[]
          // console.log('response.DATA:',response.DATA)
          setIN3_Vehicles(response.DATA.IN3_TRANSPTYPES)
          
          response.DATA.IN_ORDERS.map(function (x) {
            
            ultimo_punto=parseInt(x.order_id)
            if(x.order_mode==='shipment'){
              if(parseInt(x.order_tour_info.order_tour)!==9999)
              {puntos2.push({
                order_id:x.order_id,
                punto1: [x.order_lat1, x.order_lon1,''],
                earlyTime1: x.order_earlytime1,
                lateTime1:x.order_latetime1,
                servicetime1:x.order_servicetime1,
                position:'while',
                nombre: x.order_id,
                tour_info: {
                  transptype_type:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_routing,
                  order_tour:x.order_tour_info.order_tour,
                  order_pos:parseInt(x.order_tour_info.order_pos),
                  order_vehicle:response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype,
                  transptype:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_name,
                  transptype_capacity_items:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_capacityitems,
                  transptype_capacity_weight:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_capacityweight,
                },
                sumItems:0.0,
                sumWeight:0.0,
                numberItems: x.order_items,
                color: "yellow",
                order_mode:x.order_mode,
                peso:x.order_weight,
                hub:x.order_idhub,
                order_revenue:x.order_revenue
              });
              puntos2.push({
                order_id:x.order_id,
                punto1: [x.order_lat2, x.order_lon2,''],
                earlyTime1: x.order_earlytime2,
                lateTime1:x.order_latetime2,
                servicetime1:x.order_servicetime2,
                position:'while',
                nombre: x.order_id,
                tour_info: {
                  transptype_type:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_routing,
                  order_tour:x.order_tour_info2.order_tour,
                  order_pos:parseInt(x.order_tour_info2.order_pos),
                  order_vehicle:response.DATA.OPT1_TOURS[parseInt(x.order_tour_info2.order_tour)].tour_idtransptype,
                  transptype:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info2.order_tour)].tour_idtransptype)].transptype_name,
                  transptype_capacity_items:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info2.order_tour)].tour_idtransptype)].transptype_capacityitems,
                  transptype_capacity_weight:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info2.order_tour)].tour_idtransptype)].transptype_capacityweight,
                },
                sumItems:0.0,
                sumWeight:0.0,
                numberItems: x.order_items,
                color: "yellow",
                order_mode:x.order_mode,
                peso:x.order_weight,
                hub:x.order_idhub,
                order_revenue:x.order_revenue
              });}else{
                noMan.push({
                  order_id:x.order_id,
                  order_name:x.order_name,	
                  order_mode:x.order_mode,	
                  order_idhub:x.order_idhub,	
                  order_lat1:x.order_lat1,	
                  order_lon1:x.order_lon1,	
                  order_earlytime1:x.order_earlytime1,	
                  order_latetime1:x.order_latetime1,	
                  order_servicetime1:x.order_servicetime1,	
                  order_items:x.order_items,	
                  order_weight:x.order_weight,	
                  order_pc:x.order_pc,	
                  order_lat2:x.order_lat2,	
                  order_lon2:x.order_lon2,	
                  order_earlytime2:x.order_earlytime2,	
                  order_latetime2:x.order_latetime2,	
                  order_servicetime2:x.order_servicetime2,	
                  order_bolactivo:x.order_bolactivo,	
                  order_revenue:x.order_revenue,
                })
              }
              
            }else{
              if(parseInt(x.order_tour_info.order_tour)!==9999)
              {puntos2.push({
                order_id:x.order_id,
                punto1: [x.order_lat1, x.order_lon1,''],
                earlyTime1: x.order_earlytime1,
                lateTime1:x.order_latetime1,
                servicetime1:x.order_servicetime1,
                position:'while',
                nombre: x.order_id,
                tour_info: {
                  transptype_type:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_routing,
                  order_tour:x.order_tour_info.order_tour,
                  order_pos:parseInt(x.order_tour_info.order_pos),
                  order_vehicle:response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype,
                  transptype:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_name,
                  transptype_capacity_items:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_capacityitems,
                  transptype_capacity_weight:response.DATA.IN3_TRANSPTYPES[parseInt(response.DATA.OPT1_TOURS[parseInt(x.order_tour_info.order_tour)].tour_idtransptype)].transptype_capacityweight,
                },
                sumItems:0.0,
                sumWeight:0.0,
                numberItems: x.order_items,
                color: "yellow",
                order_mode:x.order_mode,
                peso:x.order_weight,
                hub:x.order_idhub,
                order_revenue:x.order_revenue
              });}else{
                noMan.push({
                  order_id:x.order_id,
                  order_name:x.order_name,	
                  order_mode:x.order_mode,	
                  order_idhub:x.order_idhub,	
                  order_lat1:x.order_lat1,	
                  order_lon1:x.order_lon1,	
                  order_earlytime1:x.order_earlytime1,	
                  order_latetime1:x.order_latetime1,	
                  order_servicetime1:x.order_servicetime1,	
                  order_items:x.order_items,	
                  order_weight:x.order_weight,	
                  order_pc:x.order_pc,	
                  order_lat2:x.order_lat2,	
                  order_lon2:x.order_lon2,	
                  order_earlytime2:x.order_earlytime2,	
                  order_latetime2:x.order_latetime2,	
                  order_servicetime2:x.order_servicetime2,	
                  order_bolactivo:x.order_bolactivo,	
                  order_revenue:x.order_revenue,
                })
              }
            }
              
              tours.push(x.order_tour_info.order_tour);
          });

          setorderNoManaged(noMan);
    
          puntos2.sort(function (a, b) {
            if (a.tour_info.order_tour > b.tour_info.order_tour) {
              return 1;
            } else if (a.tour_info.order_tour < b.tour_info.order_tour) {
              return -1;
            } else {
              if (a.tour_info.order_pos < b.tour_info.order_pos) {
                return -1;
              } else if (a.tour_info.order_tour > b.tour_info.order_tour) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          var puntoHub;
          var nombreHub;
          var ant=0;
          var elementAnt;
  
          for (let i = 0; i < ultimo_punto+1; i++) {
            ship_vector.push(0)
          }
          puntos2.forEach(element => {
            if(element.tour_info.order_pos===1 && ant!==0){
              for (let i = 0; i < puntos_hubs.length; i++) {
                puntoHub=puntos_hubs[parseInt(elementAnt.hub)].punto1;
                nombreHub=puntos_hubs[parseInt(elementAnt.hub)].nombre;
              }
              puntos2.push({
                position:'end',
                sumItems:0.0,
                sumWeight:0.0,
                punto1: puntoHub,
                nombre: nombreHub,
                tour_info: {
                  order_tour:elementAnt.tour_info.order_tour,
                  order_pos:elementAnt.tour_info.order_pos+1,
                  order_vehicle:0,
                  transptype:'',
                  transptype_capacity_items:0.0,
                  transptype_capacity_weight:0.0,
                },
              });
  
              for (let i = 0; i < puntos_hubs.length; i++) {
                puntoHub=puntos_hubs[parseInt(element.hub)].punto1;
                nombreHub=puntos_hubs[parseInt(element.hub)].nombre;
              }
              // console.log('elementtt:',element )
              puntos2.push({
                position:'begin',
                sumItems:0.0,
                sumWeight:0.0,
                punto1: puntoHub,
                nombre: nombreHub,
                tour_info: {
                  order_tour:element.tour_info.order_tour,
                  order_pos:0,
                  order_vehicle:0,
                  transptype_type:element.tour_info.transptype_type,
                  transptype:'',
                  transptype_capacity_items:0.0,
                  transptype_capacity_weight:0.0,
                },
              });
            }else if(element.tour_info.order_pos===1){
              for (let i = 0; i < puntos_hubs.length; i++) {
                puntoHub=puntos_hubs[parseInt(element.hub)].punto1;
                nombreHub=puntos_hubs[parseInt(element.hub)].nombre;
              }
              puntos2.push({
                position:'begin',
                sumItems:0.0,
                sumWeight:0.0,
                punto1: puntoHub,
                nombre: nombreHub,
                tour_info: {
                  order_tour:element.tour_info.order_tour,
                  order_pos:0,
                  order_vehicle:0,
                  transptype_type:element.tour_info.transptype_type,
                  transptype:'',
                  transptype_capacity_items:0.0,
                  transptype_capacity_weight:0.0,
                },
              });
            }
            ant=element.tour_info.order_pos
            elementAnt=element;
          })
  
          for (let i = 0; i < puntos_hubs.length; i++) {
            puntoHub=puntos_hubs[parseInt(elementAnt.hub)].punto1;
            nombreHub=puntos_hubs[parseInt(elementAnt.hub)].nombre;
          }
          puntos2.push({
            position:'end',
            sumItems:0.0,
            sumWeight:0.0,
            punto1: puntoHub,
            nombre: nombreHub,
            tour_info: {
              order_tour:elementAnt.tour_info.order_tour,
              order_pos:elementAnt.tour_info.order_pos+1,
              order_vehicle:0,
              transptype:'',
              transptype_capacity_items:0.0,
              transptype_capacity_weight:0.0,
            },
          });
  
          puntos2.sort(function (a, b) {
            if (a.tour_info.order_tour > b.tour_info.order_tour) {
              return 1;
            } else if (a.tour_info.order_tour < b.tour_info.order_tour) {
              return -1;
            } else {
              if (a.tour_info.order_pos < b.tour_info.order_pos) {
                return -1;
              } else if (a.tour_info.order_tour > b.tour_info.order_tour) {
                return 1;
              } else {
                return 0;
              }
            }
          });
          var SumPeso=0.0;
          var SumItems=0.0;
          var aux=0;
          
          for (let i = 0; i < puntos2.length; i++) {
            if(puntos2[i].position==='begin'){
              SumPeso=0.0;
              SumItems=0.0;
              aux=i;
            }else if(puntos2[i].position==='end'){
              puntos2[aux].sumWeight=SumPeso;
              puntos2[aux].sumItems=SumItems;
            }else{
              if(puntos2[i].order_mode==='delivery'){
                SumPeso=SumPeso+parseFloat(puntos2[i].peso)
                SumItems=SumItems+parseFloat(puntos2[i].numberItems)
              }
            }
          }
          
          for (let i = 0; i < puntos2.length; i++) {
            if(puntos2[i].position==='while'){
              if(puntos2[i].order_mode==='pickup'||
              (puntos2[i].order_mode==='shipment' && 
              ship_vector[parseInt(puntos2[i].nombre)]===0)){
                puntos2[i].sumWeight=puntos2[i-1].sumWeight+parseFloat(puntos2[i].peso);
                puntos2[i].sumItems=puntos2[i-1].sumItems+parseFloat(puntos2[i].numberItems);
                puntos2[i].sumWeight=Math.round(puntos2[i].sumWeight*100)
                puntos2[i].sumItems=Math.round(puntos2[i].sumItems*100)
                puntos2[i].sumWeight=puntos2[i].sumWeight/100
                puntos2[i].sumItems=puntos2[i].sumItems/100
                ship_vector[parseInt(puntos2[i].order_id)]=1;
                // console.log('ship0:', ship_vector[parseInt(puntos2[i].order_id)],'punto:',parseInt(puntos2[i].order_id))
              }else if(puntos2[i].order_mode==='delivery'||
              (puntos2[i].order_mode==='shipment' && 
              ship_vector[parseInt(puntos2[i].nombre)]===1)){
                puntos2[i].sumWeight=puntos2[i-1].sumWeight-parseFloat(puntos2[i].peso);
                puntos2[i].sumItems=puntos2[i-1].sumItems-parseFloat(puntos2[i].numberItems);
                puntos2[i].sumWeight=Math.round(puntos2[i].sumWeight*100)
                puntos2[i].sumItems=Math.round(puntos2[i].sumItems*100)
                puntos2[i].sumWeight=puntos2[i].sumWeight/100
                puntos2[i].sumItems=puntos2[i].sumItems/100
                // console.log('ship1:', ship_vector[parseInt(puntos2[i].order_id)],'punto:',parseInt(puntos2[i].order_id))
              }
            }else if(puntos2[i].position==='end'){
              puntos2[i].sumWeight=puntos2[i-1].sumWeight;
              puntos2[i].sumItems=puntos2[i-1].sumItems;
              puntos2[i].tour_info.order_vehicle=puntos2[i-1].tour_info.order_vehicle;
              puntos2[i].tour_info.transptype=puntos2[i-1].tour_info.transptype;
              puntos2[i].tour_info.transptype_capacity_items=puntos2[i-1].tour_info.transptype_capacity_items;
              puntos2[i].tour_info.transptype_capacity_weight=puntos2[i-1].tour_info.transptype_capacity_weight;
            }else if(puntos2[i].position==='begin'){
              puntos2[i].tour_info.order_vehicle=puntos2[i+1].tour_info.order_vehicle;
              puntos2[i].tour_info.transptype=puntos2[i+1].tour_info.transptype;
              puntos2[i].tour_info.transptype_capacity_items=puntos2[i+1].tour_info.transptype_capacity_items;
              puntos2[i].tour_info.transptype_capacity_weight=puntos2[i+1].tour_info.transptype_capacity_weight;
            }
          }

  
          
          if (puntos2.length<90){
            var dataCoord='';
            for (let i = 0; i < puntos2.length; i++) {
              var lat=puntos2[i].punto1[0];
              var long=puntos2[i].punto1[1];
              (i===0)?dataCoord=`${lat},${long}`:dataCoord=dataCoord+`|${lat},${long}`;
            }
            
            const bodyObj = {
              locations: dataCoord,
            };
            post(bodyObj,'get-elevation','get-elevation','').then((response) => {
              // getAltitude(token,dataCoord).then((response) => {
                // console.log(response)
              const elevationData=response.results
              if(elevationData.length===puntos2.length)
              { 
                for (let i = 0; i < elevationData.length; i++) {
                  (puntos2[i].punto1[0]===elevationData[i].location.lat.toString()&&
                  puntos2[i].punto1[1]===elevationData[i].location.lng.toString())
                  ?puntos2[i].punto1[2]=`${elevationData[i].elevation}`
                  :console.log('error en:',i)
                }
              }
            });
             
          }else{
            var dataCoord=''; //nuevo
            var breakAct=false;
            for (let j = 0; j < aux; j++) {
              dataCoord='';
              // dataCoord[j]='';
              
              for (let i = 0; i < 95; i++) {
                if(puntos2[95*j+i+1]==null || puntos2[95*j+i+1]=='undefined'){
                  // console.log('cucu',breakAct,i,j)
                  var lat=puntos2[95*j+i].punto1[0];
                  var long=puntos2[95*j+i].punto1[1];
                  (i===0)?dataCoord=`${lat},${long}`:dataCoord=dataCoord+`|${lat},${long}`;
                  // console.log((puntos2[95*j+i+1]==null || puntos2[95*j+i+1]=='undefined'),puntos2[95*j+i])
                  breakAct=true
                  // console.log('cucu',breakAct)
                  break;
                }else{
                  var lat=puntos2[95*j+i].punto1[0];
                  var long=puntos2[95*j+i].punto1[1];
                  (i===0)?dataCoord=`${lat},${long}`:dataCoord=dataCoord+`|${lat},${long}`;
                  // (i===0)?dataCoord[j]=`${lat},${long}`:dataCoord[j]=dataCoord[j]+`|${lat},${long}`;
                  // console.log(j,i,95*j+i,95*j+i+1,(puntos2[95*j+i+1]==null || puntos2[95*j+i+1]=='undefined'),puntos2[95*j+i])
                }
              }
              const bodyObj = {
                locations: dataCoord,
                // locations: dataCoord[j],
              };
              post(bodyObj,'get-elevation','get-elevation','').then((response) => {
              // getAltitude(token,dataCoord[j]).then((response) => {
                const elevationData=response.results
                
                  for (let i = 0; i < elevationData.length; i++) {
                    (puntos2[95*j+i].punto1[0]===elevationData[i].location.lat.toString()&&
                    puntos2[95*j+i].punto1[1]===elevationData[i].location.lng.toString())
                    ?puntos2[95*j+i].punto1[2]=`${elevationData[i].elevation}`
                    :console.log('error en:',i)
                  }
                
              });
              if(breakAct)break
            }
          }
          
          setpuntos(puntos2);
          // console.log('response.DATA:',response.DATA)
          setdata_MAX_FLEET_INFO(response.DATA.MAX_FLEET_INFO);
          
          // setdata_OPT1_TOURS(response.DATA.OPT1_TOURS);
  
          col = [];
          Object.keys(response.DATA.OPT1_TOURS[0]).map(function (x) {
            col.push({ title: x, dataIndex: x, key: x });
          });
          setcol_OPT1_TOURS(col);
          col = [];
          setdata_OUT1_TOTAL(response.DATA.OUT1_TOTAL);
          Object.keys(response.DATA.OUT1_TOTAL[0]).map(function (x) {
            col.push({ title: x, dataIndex: x, key: x });
          });
          setcol_OUT1_TOTAL(col);
          
        });
      }else{sethayData(false) 
        // sethayError(true)
      }
    });
    
  }, [setSelectedSimualtion,SelectedSimualtion,viewother, setviewother]); 

  var config1 = {
    data: OUT3_Tours,
    isGroup: true,
    xField: "type",
    yField: "value",
    seriesField: "name", 
    label: {
      position: "top",
      layout: [
        { type: "interval-adjust-position" },
        { type: "interval-hide-overlap" },
        { type: "adjust-color" },
      ],
    },
  };

  function selectSubsim(value){
    setSelectedSimualtion(value)
  }

  async function updateResults(){
    // setSelectedSimualtion(value)
    var ids='';
    var sub=true;
    if(SelectedSimualtion.length<1  || (SelectedSimualtion.length>1 &&SelectedSimualtion===code)){
      sub=false;
    }

    (SelectedSimualtion.length<1  && cambios==='1')
    ?ids=code
    :(SelectedSimualtion.length>1  && cambios==='1' &&SelectedSimualtion===code)
      ?ids=code
      :ids=SelectedSimualtion;

    // console.log('sub: ',sub);
    // console.log('ids: ',ids);
    var data={
      subsimulation:ids
    }

    if(sub){
      await post(data,'busca-ita-multiple','busca-ita-multiple',`/${code}`)
    }else{
      // await downloadFilefromIta(token,ids)
      await get('busca-ita','busca-ita',`/${ids}`)
    }
    // (sub)
    //   ?await downloadFilefromItaSub(token,code,ids)
    //   :await downloadFilefromIta(token,ids)

    setviewother(!viewother)
  }
  
  // console.log('SelectedSimualtion: ',SelectedSimualtion)
  // console.log('cambios: ',cambios)
  // console.log('code: ',code)
  // console.log('nombreInput: ',nombreInput)
  // console.log((SelectedSimualtion.length<1  && cambios==='1') )
  // console.log((SelectedSimualtion.length>1  && cambios==='1' &&SelectedSimualtion===code))
  // console.log((SelectedSimualtion.length>1  && data_OUT1_TOTAL.length<1 &&SelectedSimualtion!==code))

  return (
    <>
     
        <div>
        <Row justify="space-between" gutter={16}>
          <Col span={12}>
            <h1 style={{fontFamily:'report-bold'}}>Simulation: {nombre}&nbsp;&nbsp;&nbsp;{fecha}&nbsp;&nbsp;&nbsp;</h1>
          </Col> 
          <Row span={6}>
              <Select 
                onChange={value => selectSubsim(value)}
                placeholder="Choose a subsimulation">
                {subsimulations}
              </Select>
              <div  style={{width:'10px',}} ></div>
            {
              ( 
                (SelectedSimualtion.length<1  && cambios==='1') ||
                (SelectedSimualtion.length>1  && cambios==='1' &&SelectedSimualtion===code) ||
                (!hayData)
              )
                ?<Button 
                  type="primary" 
                  style={{
                    backgroundColor:'white',
                    borderWidth:'2px',
                    borderColor:'orange',
                    fontSize:'15px',
                    color:'orange',
                    fontFamily:'report-bold',
                  }} 
                  onClick={()=>updateResults()}>
                  Update results
                </Button>
                  :<Button className="boton"
                      disabled={true}
                      style={{
                        backgroundColor:'rgb(220,220,220)',
                        borderWidth:'2px',
                        color:'grey',
                        fontFamily:'report',
                        fontSize:'15px',
                        borderColor:'grey',
                      }}>
                    Update results
                  </Button>
            }
          </Row> 
        </Row> 
      </div>  
     { (hayError)
        ?<h2 style={{fontFamily:'report-bold'}}>This simulation has errors, check the inputs to solve them.</h2>
        :(hayData)?
      <div className="site-card-wrapper">
        {/* <span>{csv}</span> */}

        <Tabs defaultActiveKey="1" onChange={() => {}} >
          <Tabs.TabPane tab="Performance" key="Performance"  style={{fontFamily:'report'}}>
            <h1 className="titulos3" >OPERATIONAL PERFORMANCE OF THE FLEET </h1>
            <Card title="Info of vehicles: " bordered={false} style={{fontFamily:'report-bold'}}>
               <Row justify="space-around" gutter={16}>
                <div className="circulos">
                  <Row span={4}>
                    <div >
                      <p style={{fontFamily:'report'}}>
                        Fleet used weight: {data_MAX_FLEET_INFO.fleet_used_weight}{" "}
                        kg
                      </p>
                      <p style={{fontFamily:'report'}} >
                        Fleet max weight: {data_MAX_FLEET_INFO.fleet_max_weight}{" "}
                        kg
                      </p>
                    </div>
                  </Row>
                  <Col className="progress" span={4}>
                    <ProgressBar
                      percentage={data_MAX_FLEET_INFO.fleet_performance}
                    />
                  </Col>
                </div>
                <div className="circulos">
                  <Row span={4}>
                    <div>
                      <p style={{fontFamily:'report'}}>
                        Fleet used weight: {data_MAX_FLEET_INFO.fleet_used_weight}{" "}
                        kg
                      </p>
                      <p style={{fontFamily:'report'}}>
                        Fleet max capacity:{" "}
                        {data_MAX_FLEET_INFO.fleet_max_capacity} (vol)
                      </p>
                    </div>
                  </Row>
                  <Col className="progress" span={4}>
                    <ProgressBar
                      percentage={redondear_numero(
                        (data_MAX_FLEET_INFO.fleet_used_weight * 100) /
                          data_MAX_FLEET_INFO.fleet_max_capacity,
                        1
                      )}
                    />
                  </Col>
                </div>
                <div className="circulos">
                  <Row span={4}>
                    <div>
                      <p style={{fontFamily:'report'}}>
                        Fleet max weight: {data_MAX_FLEET_INFO.fleet_max_weight}{" "}
                        kg
                      </p>
                      <p style={{fontFamily:'report'}}>
                        Fleet max capacity:{" "}
                        {data_MAX_FLEET_INFO.fleet_max_capacity} (vol)
                      </p>
                    </div>
                  </Row>
                  <Col className="progress" span={4}>
                    <ProgressBar
                      percentage={redondear_numero(
                        (data_MAX_FLEET_INFO.fleet_max_weight * 100) /
                          data_MAX_FLEET_INFO.fleet_max_capacity,
                        1
                      )}
                    />
                  </Col>
                </div>
                <Col span={8}></Col>
              </Row>
              <br></br>
              <Row justify="space-around" gutter={16}>
              <div className="circulos">
                <div span={4}>
                  <div style={{fontFamily:'report'}}>Average fill rate of</div>
                  <div style={{fontFamily:'report'}}>the used vehicles</div>
                </div>
                <Col className="progress"  span={4}>
                  <ProgressBar percentage={avarage_fill_rate} />
                </Col>
                </div>
                <div className="circulos">
                <Row span={4}>
                  <div style={{fontFamily:'report'}}>Capacity total used</div>
                </Row>
                <Col className="progress"  span={4}>
                  <ProgressBar percentage={capacity_total_used} />
                </Col>
                </div>
                <div className="circulos">
                <div  span={4}>
                  <div style={{fontFamily:'report'}}>Percentage of use of </div>
                  <div style={{fontFamily:'report'}}>the vehicles (in time)</div>
                </div>
                <Col span={4}>
                  <ProgressBar percentage={percentage_of_use} />
                </Col>
                </div>
              </Row>  
             
            </Card>
            <br></br>

            <Row>
              <Col span={24}>
                <h1 className="titulos3">
                  ENVIROMENTAL AND FINANCIAL PERFORMANCE OF THE FLEET
                </h1>
                <Card title="Performance: " bordered={false}  style={{fontFamily:'report-bold'}}>
                  <TableNoEditable
                      datos={data_OUT1_TOTAL}
                      tipo={'performance'}
                      />  
                </Card>
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Tours" key="Tours"  style={{fontFamily:'report'}}>
            <Row justify="center" gutter={16}>
              <Col span={16}>
                <h1 className="titulos2">TOURS PERFORMANCE</h1>
                <Card title="Info of tours: " bordered={false}>
                  <Column {...config1} />
                </Card>
              </Col>
              <Col span={8}>
                <h1 className="titulos2">TOURS GENERATED</h1>
                <TableNoEditable
                      datos={data_OPT1_TOURS}
                      tipo={'tours'}
                      />  
              </Col>
            </Row>
            <br></br>
            <Row justify="center" gutter={16}>
              <Col span={24}>
                <h1 className="titulos2">TOURS_OUTPUT</h1>
                 <TableNoEditable
                      datos={tours_capacity_JSON.data_tours}
                      tipo={'tours_out'}
                      />  
              </Col>
            </Row>
            <Row justify="center" gutter={16}>
              <Col justify="center" span={24}>
                <h1 className="titulos2">TOURS_PLOTED</h1>
                <Card title="Tours: " bordered={false}>
                  <Map_polilineas coordenadas={puntos} />
                </Card>
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Economics" key="Economics" style={{fontFamily:'report'}} >
          <Billing 
          datosTotales={totalData} 
          setiva={setiva} 
          iva={iva} 
          rutas={puntos}></Billing>
          <Row justify="center" gutter={16}>
              <Col justify="center" span={24}>
                <Card title=" " bordered={false}>
                  <Map_economy  datosTotales={totalData}  coordenadas={puntos} iva={iva} />
                </Card>
              </Col>
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Unmanaged" key="Unmanaged" style={{fontFamily:'report'}} >
          {(orderNoManaged.length>0)
          ?<>
            <Row justify="center" gutter={16}>
                <Col span={24}>
                  <h1 className="titulos2">NO MANAGED ORDERS</h1>
                  <TableNoEditable
                        datos={orderNoManaged}
                        tipo={'orderNoManaged'}
                        />  
                </Col>
              </Row>
              <p></p>
              <Row justify="center" gutter={16}>
                <Col justify="center" span={24}>
                  <h1 className="titulos2">ORDERS AND TOURS</h1>
                    <Map_nomanaged noManaged={orderNoManaged} coordenadas={puntos} />
                </Col>
              </Row>
            </>
            :<>
              <p></p>
              <h1 className="titulos2">ALL ORDERS MANAGED</h1>
            </>
            }
          </Tabs.TabPane>
          <Tabs.TabPane tab="Real Data" key="real_data"  style={{fontFamily:'report'}}>
            {
            (rr_bool)
            // (real_data.length>0)
            ?<div>
              <Map_real coordenadas={puntos} routes_data={real_data} total={totalData}/>
            </div>
            :<h1 className="titulos2">ADD YOUR REAL ROUTES TO COMPARE</h1>}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Summary" key="Summary"  style={{fontFamily:'report'}}>
            <Row justify="center" gutter={16}>
              <Col span={8}>{quentincontenedores}</Col>
              <Col span={8}>{quentinvehiculos}</Col>
              <Col span={8}>{quentindemand}</Col>
            </Row>
          </Tabs.TabPane>
        </Tabs>
      </div>
      :<h2 style={{fontFamily:'report-bold'}}>Update results to show them...</h2>
      }
    </>
  );
}
